import { render, staticRenderFns } from "./SingleComment.vue?vue&type=template&id=5decca2c&scoped=true&"
import script from "./SingleComment.vue?vue&type=script&lang=js&"
export * from "./SingleComment.vue?vue&type=script&lang=js&"
import style0 from "./SingleComment.vue?vue&type=style&index=0&id=5decca2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5decca2c",
  null
  
)

export default component.exports